export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10244.381d1d46.jpg";